import { Button } from "flowbite-react";
import React from "react";
import { useNavigate } from "react-router";

function PreFooter() {
  const navigate = useNavigate();
  return (
    <section className="relative text-center bg-[url('./img/banner-4.png')] bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center space-y-8 py-14 px-4">
        <h3 className="text-2xl font-semibold text-[#00ABA5]">JOIN OUR TEAM OF PASSIONATE LEARNERS</h3>
        <p className="px-4 lg:max-w-[50%] leading-tight text-white text-xl">If you are interested to join our team, please get in touch with us</p>
        <Button
          className="!bg-[#00ABA5] min-w-[200px] mb-10 hover:shadow-lg hover:-translate-x-px hover:shadow-[#00ABA5]/20"
          onClick={() => navigate("/contactus")}
        >
          Contact us
        </Button>
    </section>
  );
}

export default PreFooter;
